export default {
    path: '/dga-salary-admin/:id',
    component: () => import('@/components/DgaSalaryAdmin/DgaSalaryAdminView.vue'),
    name: 'dga-salary-admin-client-details',
    meta: {
        private: true,
        dossier: 'client',
    },
};
